module.exports = __webpack_public_path__ + "themes/non-default/addeparStep2PortfolioName.bcba53c35bd0f660fbf53a4e57dba67c.png";